import { formatDate as formatDisplayDate } from "../../Utils/dateFormat";


export const formatDate = (date) => formatDisplayDate(date);
